module.exports = __webpack_public_path__ + "img/Perfect-Fit-1110x450.4985615b.png";